import { defineStaticListFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

export const DATA_ADJUSTMENTS_OPTIONS = [
  { value: 'true', label: 'Unadjusted', limit: 1 },
  { value: '', label: 'Adjusted', limit: 1 },
];

export const dataAdjustmentsDescriptor = defineStaticListFilter({
  definition: {
    id: FilterId.DATA_ADJUSTMENTS,
    name: 'Data Adjustments',
    selections: [],
    type: FilterType.STATIC_LIST,
    isVisible: true,
  },
});
